import React from 'react'
import { AdminState } from './Context'
import { useNavigate } from 'react-router-dom'


export const Navbar = () => {

    const { admin, setAdmin } = AdminState()
    const navigate = useNavigate()

    return (
        <div className='navigation'>
            <nav className="navbar navbar-expand-md navbar-dark mb-1 my-auto" style={{ backgroundColor: "#409fd5" }}>
                <div className="flex-row d-flex my-auto justify-content-center align-items-center">
                    <button type="button" className="navbar-toggler mr-2 " data-toggle="offcanvas" title="Toggle responsive left sidebar">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <img src='/logo.81e14bae7abf63931be9.webp' className='img-fluid logo'></img>
                </div>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="navbar-collapse collapse" id="collapsingNavbar">
                    <ul className="navbar-nav">
                        <li className="nav-item active">
                            {/* <a className="nav-link" href="#">Home <span className="sr-only">Home</span></a> */}
                        </li>
                        {/* <li className="nav-item">
                            <a className="nav-link" href="//www.codeply.com">Link</a>
                        </li> */}
                    </ul>
                    <ul className="navbar-nav ml-auto">
                        {/* <li className="nav-item">
                        <a className="nav-link" href="#myAlert" data-toggle="collapse">Alert</a>
                    </li> */}
                        {admin && admin.token ?
                            <li className="nav-item my-auto">
                                <h5 style={{ color: "white", cursor: "pointer" }}
                                    onClick={() => {
                                        setAdmin({})
                                        navigate('/login')
                                    }}
                                >Logout</h5>
                            </li>
                            :
                            <li className="nav-item">
                                <h5 style={{ color: "white", cursor: "pointer" }}
                                    onClick={() => {
                                        // setAdmin({})
                                        navigate('/login')
                                    }}
                                >LogIn</h5>
                            </li>
                        }
                        {/* <li className="nav-item">
                        <a className="nav-link waves-effect waves-light text-white">
                            <i className="fab fa-google-plus-g"></i>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link waves-effect waves-light text-white">
                            <i className="fas fa-envelope-open-text"></i>
                        </a>
                    </li> */}
                        {/* <li className="nav-item">
                        <a className="nav-link waves-effect waves-light text-white">
                            <i className="fas fa-align-justify"></i>
                        </a>
                    </li> */}
                    </ul>
                </div>
            </nav>
        </div>
    )
}
export default Navbar